// @flow
import { normalize } from 'normalizr'
import typeToReducer from 'type-to-reducer'

import type { Genre } from '@alphaott/api-client/types/genres'
import type { GenresNormalize } from '@alphaott/common-types/normalized'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import { genresListSchema, defaultToEmptyObject } from '@alphaott/common-utils'

import { FETCH_TVSHOW_GENRES } from '../../actions/tvshowGenres'

export type TVShowGenresState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +data: Array<Genre>,
  +entities: GenresNormalize,
  +expires: ?number,
}

const initialState: TVShowGenresState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  entities: {},
  expires: null,
}

const tvshowGenres = typeToReducer(
  {
    [FETCH_TVSHOW_GENRES]: {
      LOADING: (state): TVShowGenresState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): TVShowGenresState => {
        const {
          payload,
          meta: { ttl },
        } = action
        const { entities } = normalize(payload.data, genresListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          data: action.payload.data,
          entities: defaultToEmptyObject(entities.genres),
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): TVShowGenresState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { tvshowGenres }
